<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">

         <z-page title="Senarai : Mel ">

             <w-form >
                <w-flex justify-space-between class="mb4">
                     <div class="xs4"> 
                        <w-input placeholder="Sila No Daftar Mel"  v-model="cari.no_rujukan" name="no_rujukan" >No Rujukan  </w-input>
                    </div>
                    <div class="xs4">
                        <z-input 
                              label="Tarikh Daftar" 
                              name="tarikh_daftar" 
                              v-model="cari.tarikh_daftar" 
                               type="date"/>
                    </div>
                    <div class="xs4">
                        <z-input 
                              label="Tarikh Hingga" 
                              name="tarikh_hingga" 
                              v-model="cari.tarikh_hingga" 
                               type="date"/>
                    </div>
                </w-flex>
                <w-flex justify-space-between class="mb4">
                     <div class="xs4"> 
                      <z-lookup label="Status" name="status" :url='service_kutipan+"lookup/status_mel"' :sort="false" :cache="false" v-model="cari.lkp_terimaan_pukal_status_id" />
                    </div>
              </w-flex>

            </w-form>

            <w-flex class="mt3 mb3" wrap align-center justify-end>
              <div class="text-right">
                  <w-button class="ml1" v-on:click="reset()" bg-color="warning">
                      <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                  </w-button>
                  <w-button class="ml1 " @click="search()">
                    <w-icon>fal fa-search</w-icon>&nbsp;Cari
                  </w-button>
              </div>
            </w-flex>


            <center v-if="loading"><w-progress class="ma1" circle></w-progress></center>

            <z-table ref="tbluser" title="Senarai : Mel" :headers="table.headers" :items="table.items" :meta="table.meta" class="">
                <template #item-cell.action="{ item, label, header, index }">
                  <w-flex class="flex justify-center">
                    <!-- <inertia-link :href='$route("kutipan.mel.papar")+"/"+item.no_rujukan+"/"+item.profil_id+"/"+item.lkp_terimaan_pukal_status_id+"/"+item.tarikh_sedia'> -->

                    <inertia-link :href='$route("kutipan.mel.show",item.id)'>
                        <w-tooltip top>
                            <template #activator="{ on }">
                                <w-icon v-on="on" >
                                    fal fa-file
                                </w-icon>
                            </template>
                            Papar
                        </w-tooltip>
                    </inertia-link>&nbsp;&nbsp;

                        <!-- <w-button bg-color="success" class="mr3" @click="salinan(item.id)">
                              <w-icon>fal fa-copy</w-icon>
                              &nbsp;Salinan
                        </w-button> -->
                            <w-icon dark tile @click="salinan(item.id)">fal fa-copy</w-icon>
                  </w-flex>
                </template>
            </z-table>

        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from 'vue'
// import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    items: [Array, Object],
  },
  data() {
    return {
        resourceurl: this.service_kutipan+'terimaan_pukal',
        reload: true,
        loading: true,
        crumbs: [
        { label: 'iHasil', route: '/' },
        { label: 'Kutipan', route: '/kutipan' },
        { label: 'Mel', route: '/kutipan/mel' },
        { label: 'senarai', route: '/kutipan/mel' },
          ],
          form: {
            no: '',
            no_dokumen: '',
            },
          cari : {no_rujukan:'', profil_id:'' ,lkp_terimaan_pukal_status_id:'', tarikh_daftar: '', tarikh_hingga: ''},

        }
  },
  methods: {
    search() {
      var url = window.route('kutipan.mel.index')+'?no_rujukan='+this.cari.no_rujukan+'&lkp_terimaan_pukal_status_id='+this.cari.lkp_terimaan_pukal_status_id+'&profil_id='+this.cari.profil_id+'&tarikh_daftar='+this.cari.tarikh_daftar+'&tarikh_hingga='+this.cari.tarikh_hingga;
      this.$inertia.visit(url, { preserveScroll : true})
    },
    reset(){
        this.cari = {no_rujukan: '',profil_id: '', lkp_terimaan_pukal_status_id: '', tarikh_daftar: '', tarikh_hingga: ''}
        this.search()
    },

    salinan(id) {

     // alert(id);
      this.$zcomm.get(this.resourceurl + '/duplicate/'+id)
          .then(res => {

              this.$inertia.visit(this.$route('kutipan.mel.index'))
          })
         
          .catch(err => {

          })
          .finally(() => {
              // this.$inertia.visit(this.$route('kutipan.mel.index'))
          });
      },

      load() {
            // this.loading = true
            this.$zcomm.get(this.service_kutipan +'terimaan_pukal'+window.location.search)
            .then(res => {
              })
            .finally(() => {

                this.loading = false
                });
        },


  },

  watch: {

  },
  mounted() {
    this.load();
    this.dialog.width = 500
    this.cari = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.cari.no_rujukan == 'undefined'){this.cari.no_rujukan = ''}
    if(this.cari.profil_id == 'undefined'){this.cari.profil_id = ''}
  },
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
